import React from 'react';
import { modules } from '../data/modules';
export function ModulesSection() {
  return <section id="moduli" className="bg-brand-cream px-4 py-7" data-id="element-105" data-mp="1nuxtv0c8ezz0">
      <div className="mx-auto max-w-2xl" data-id="element-106" data-mp="1nsl789vj41fm">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-107" data-mp="1iv1pgzzmh6ix">
          Ecco cosa troverai all’interno
        </h2>

        <div className="mt-4 space-y-3" data-id="element-108" data-mp="2bk8soca0ukai">
          {modules.map(module => <article key={module.num} className="rounded-lg border-2 border-brand-green/40 bg-white p-4" data-id="element-109" data-mp="2bhwb4086ebxz">
              <div className="flex items-start gap-2.5" data-id="element-110" data-mp="21l1ddjjq8fkr">
                <span className="mt-0.5 shrink-0 rounded bg-brand-navy px-2 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white" data-id="element-111" data-mp="21nvv33bcvmah">
                  Modulo {module.num}
                </span>
                <h3 className="font-display text-[15px] font-extrabold uppercase leading-tight text-brand-green sm:text-base" data-id="element-112" data-mp="l7t1myc5fldr">
                  <span aria-hidden="true" data-id="element-113" data-mp="1iuz1gbm41pzb">✅</span> {module.title}
                </h3>
              </div>

              <div className="mt-2 space-y-1.5 text-sm font-medium leading-snug text-brand-graphite" data-id="element-114" data-mp="1nta9cgsuhqew">
                {module.intro.map(line => <p key={line} data-id="element-115" data-mp="18zf4rmzq2n9i">{line}</p>)}
              </div>

              {module.chips && <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-116" data-mp="1050tdvibbwvo">
                  {module.chips.map(chip => <li key={chip} className="rounded border border-brand-navy/15 bg-brand-cream px-2 py-1 text-[12px] font-semibold leading-tight text-brand-navy" data-id="element-117" data-mp="14vzdl66f9f47">
                      {chip}
                    </li>)}
                </ul>}

              {module.highlight && <p className="mt-2 rounded border-l-4 border-brand-orange bg-brand-orange/10 px-3 py-2 text-[13px] font-extrabold leading-snug text-brand-navy" data-id="element-118" data-mp="l7grwykmkju9">
                  {module.highlight}
                </p>}

              {module.outro && <div className="mt-2 space-y-1 text-sm font-medium leading-snug text-brand-graphite" data-id="element-119" data-mp="2j245z54jf8j1">
                  {module.outro.map(line => <p key={line} data-id="element-120" data-mp="295r95ydp4ek2">{line}</p>)}
                </div>}
            </article>)}
        </div>
      </div>
    </section>;
}